const mvSwiper = new Swiper('.mv-swiper', {
    // Optional parameters
    loop: false,
    effect: 'slide',
    slidesPerView: 1.1,
    spaceBetween: 10,
    // If we need pagination
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  });
